import React from "react";

export default function VentilatorTile({ model, title }) {
  return (
    <React.Fragment>
      <div className="title">{title}</div>
      <div className="ventilator tile-content">
        {model.fields.length ? (
          model.fields.map((field, i) => (
            <div className="field" key={i}>
              <div className="name">{field.name}</div>
              <div className="value">{field.value}</div>
            </div>
          ))
        ) : (
          <div className="no-data">No Vent Data</div>
        )}
      </div>
    </React.Fragment>
  );
}
